import React, { useEffect, useState, forwardRef } from 'react';
import styled from '@emotion/styled';
import {
  Experimental__IconHash as IconHash,
  FormInput,
  FormInputIcon,
} from '@spotify-internal/encore-web';
import { FieldController } from 'shared/FieldController';
import { FieldHexProps, HexInputProps } from './types';

const ColorPreview = styled.div<{
  backgroundColor: string;
}>`
  width: 24px;
  height: 24px;
  border: 1px solid #dfe0e1;
  border-radius: 4px;
  background-color: ${props => props.backgroundColor};
`;

const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

const isValidHexValue = (value: string): boolean => hexRegex.test(value);

export const FieldHex = forwardRef(
  (
    { name, value, containerClassName, ...rest }: HexInputProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const [isValidHex, setIsValidHex] = useState(false);
    const [hexValue, setHexValue] = useState(`#${value}`);
    useEffect(() => {
      setIsValidHex(isValidHexValue(hexValue));
    }, [hexValue]);
    useEffect(() => {
      setHexValue(`#${value}`);
    }, [value]);

    // TODO https://anchorfm.atlassian.net/browse/WHEEL-898: Replace the hash icon with a bespoke Anchor icon
    return (
      <div className={containerClassName}>
        <FormInputIcon
          iconLeading={
            <IconHash aria-label="Hash symbol that precedes a hex color code" />
          }
          iconTrailing={
            <ColorPreview
              backgroundColor={isValidHex ? hexValue : 'transparent'}
            />
          }
        >
          <FormInput
            style={{ textTransform: 'uppercase' }}
            ref={ref}
            {...rest}
            type="text"
            value={value}
            data-cy={name}
          />
        </FormInputIcon>
      </div>
    );
  }
);

export const ControlledFieldHex = (props: FieldHexProps) => (
  <FieldController<HexInputProps, HTMLInputElement> as={FieldHex} {...props} />
);
